export enum MyProjectStatusBarTranslateEnum {
    DRAFT = 'Entwurf',
    REQUEST = 'Anfrage übermittelt',
    IN_PROCESS = 'In Bearbeitung',
    QUOTE_SENT = 'Angebot übermittelt',
    REJECTED = 'Als Projekt abgelehnt',
    PROJECT_WON = 'Projekt gewonnen',
    DELETED = 'Projekt gelöscht',
    QUOTE_SENT_MANUALLY = 'Angebot übermittelt',
    PROJECT_LOST = 'Projekt verloren'
}



export enum MyProjectStatusSelectTranslateEnum {
    DRAFT = 'Entwurf',
    REQUEST = 'Anfrage übermittelt',
    IN_PROCESS = 'in Bearbeitung',
    QUOTE_SENT = 'Angebot übermittelt',
    REJECTED = 'Angebot abgelehnt',
    PROJECT_WON = 'Angebot gewonnen',
    DELETED = 'Projekt gelöscht',
    QUOTE_SENT_MANUALLY = 'Angebot übermittelt',
    PROJECT_LOST = 'Projekt verloren'
}


export enum MyProjectStatusDetailsCSVTranslateEnum {
    PRICE_APPROVAL_REQUESTED = 'Preise wurden zur Preisfreigabe versendet',
    PRICES_APPROVED = 'Preise wurden freigegeben',
    PRICES_REJECTED = 'Preise wurden abgelehnt',
    NONE= '',
    REQUEST_UPDATED= 'Anfrage wurde geändert',
    DATE_OVERDUE= 'Zuschlagsdatum wurde überschritten',
}
